import UniqueSellingPoints from '~/themes/base/components/shop/UniqueSellingPoints'

export default {
  extends: UniqueSellingPoints,
  data() {
    return {
      pointsIcons: {
        '10000-skladem': require('@icon/10000-skladem.svg?raw'),
        'ne-skladem-na-miru': require('@icon/ne-skladem-na-miru.svg?raw'),
        'cz-eu': require('@icon/cz-eu.svg?raw'),
        'bezpecne-i-rozmerne': require('@icon/bezpecne-i-rozmerne.svg?raw'),
      },
    }
  },
}
